"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureAppContainer = FeatureAppContainer;
const React = __importStar(require("react"));
const feature_hub_context_1 = require("./feature-hub-context");
const feature_app_context_1 = require("./internal/feature-app-context");
const internal_feature_app_container_1 = require("./internal/internal-feature-app-container");
/**
 * The `FeatureAppContainer` component allows the integrator to bundle Feature
 * Apps instead of loading them from a remote location. It can also be used by
 * a Feature App to render another Feature App as a child.
 *
 * When a Feature App throws an error while rendering or, in the case of a
 * [[ReactFeatureApp]], throws an error in a lifecycle method, the
 * `FeatureAppContainer` renders `null`. On the server, however, rendering
 * errors are not caught and must therefore be handled by the integrator.
 */
function FeatureAppContainer(props) {
    return (React.createElement(feature_hub_context_1.FeatureHubContextConsumer, null, ({ featureAppManager, logger }) => (React.createElement(feature_app_context_1.FeatureAppContext.Consumer, null, (parentFeatureApp) => (React.createElement(internal_feature_app_container_1.InternalFeatureAppContainer, Object.assign({ featureAppManager: featureAppManager, logger: logger, parentFeatureApp: parentFeatureApp }, props)))))));
}
//# sourceMappingURL=feature-app-container.js.map